<template>
  <v-row id="download-wallet">
    <v-col>
      <v-img
        v-if="apple"
        @click="download"
        contain
        max-height="100"
        max-width="256"
        src="@/assets/add-to-apple-wallet-logo2.png"
        class="clickable_image"
      ></v-img>
      <v-img
        v-else
        @click="download"
        contain
        max-height="100"
        max-width="256"
        src="@/assets/add-to-android-wallet-logo2.png"
        class="clickable_image"
      ></v-img>
      <div class="body-1 py-3" style="max-width:280px;">
        {{ getDescription }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    apple: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  name: "DownloadWallet",

  computed: {
    getDescription() {
      if (this.apple) {
        return this.$t("message.download_apple_wallet");
      }
      return this.$t("message.download_android_wallet");
    }
  },
  methods: {
    download() {
      this.$store.dispatch("wallet/wallet").then(response => {
        let fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/vnd.apple.pkpass" })
        );

        let fileLink = document.createElement("a");

        fileLink.href = fileURL;

        fileLink.setAttribute("download", "file.pkpass");

        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  }
};
</script>

<style scoped>
.clickable_image {
  cursor: pointer;
}
</style>
